import React, {useEffect, useState} from "react";
import {Button, Card, message, Select} from "antd";
import {PasswordControllerApi, PasswordDto} from "../../../api";
import {useKeycloakHeader} from "../../../config/Config";


interface PasswordFunctionProps {
    onSave: (expression: string) => void;
}

/**
 * Eine Funktions-Komponente, welche die alle Passwörter abfragt und als Dropdown-Menü zur Verfügung stellt
 * Nach dem auswählen und Speichern wird ein Funktionsstring zurückgegeben z.B password(1).
 * Die 1 steht dabei für die jeweilige ID des Passworts
 * @param onSave
 * @constructor
 */
const PasswordFunctions: React.FC<PasswordFunctionProps> = ({onSave}) => {

    const [passwords, setPasswords] = useState<PasswordDto[]>([]);
    const [selectedPasswordId, setSelectedPasswordId] = useState<string | undefined>();

    const headers = useKeycloakHeader();
    const passwordControllerApi = new PasswordControllerApi();

    useEffect(() => {
        fetchPasswords();
    }, []);


    const fetchPasswords = async () => {
        passwordControllerApi
            .getPasswords(headers) // Verwende das ausgewählte System
            .then((axiosResponse) => {
                const axiosData: Array<PasswordDto> = axiosResponse.data;
                setPasswords(axiosData);
            })
            .catch((error) => {
                message.error("Es ist ein Fehler beim Abrufen von Passwörtern entstanden!")
            });
    };


    const handleSave = () => {
        if (selectedPasswordId) {
            const expression = `password(${selectedPasswordId})`;
            onSave(expression);
        } else {
            message.warning("Bitte ein Passwort auswählen!");
        }
    };


    return (
        <Card title="Passwort" bordered={false}>
            <Select
                placeholder="Passwort auswählen"
                style={{ width: '100%', marginBottom: '16px' }}
                onChange={(value: string) => setSelectedPasswordId(value)}
                notFoundContent="Keine Passwörter verfügbar"
            >
                {passwords.map((password) => (
                    <Select.Option key={password.id} value={password.id}>
                        {password.name}
                    </Select.Option>
                ))}
            </Select>
            <Button type="primary" onClick={handleSave} style={{ marginRight: '8px' }}>
                Speichern
            </Button>
            <Button onClick={fetchPasswords}>
                Aktualisieren
            </Button>
        </Card>
    );
};

export default PasswordFunctions;

